var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    fill: "white",
    stroke: "#404040"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_333",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8335 27.5C15.3752 27.5 14.9828 27.3368 14.6564 27.0104C14.33 26.684 14.1668 26.2917 14.1668 25.8333V15H13.3335V13.3333H17.5002V12.5H22.5002V13.3333H26.6668V15H25.8335V25.8333C25.8335 26.2917 25.6703 26.684 25.3439 27.0104C25.0175 27.3368 24.6252 27.5 24.1668 27.5H15.8335ZM24.1668 15H15.8335V25.8333H24.1668V15ZM17.5002 24.1667H19.1668V16.6667H17.5002V24.1667ZM20.8335 24.1667H22.5002V16.6667H20.8335V24.1667Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b72237be9ad1b5c8c3c819b55a26d4ca.svg";
export { ForwardRef as ReactComponent };